import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { TenantConfiguration } from '../services/tenant-config-service';

interface TenantState {
  config: TenantConfiguration | null;
  setConfig: (config: TenantConfiguration | null) => void;
  reset: () => void;
}

export const useTenantStore = create<TenantState>()(
  persist(
    (set) => ({
      config: null,
      setConfig: (config) => set({ config }),
      reset: () => set({ config: null }),
    }),
    {
      name: 'tenant-storage',
    }
  )
);
